export const formatAddress = (order = {}) => {
  if (!order) return "";
  const parts = [
    order.address,
    order.number,
    order.district,
    order.city,
    order.state,
    order.postalCode,
    order.country,
  ]
    .filter(Boolean)
    .join(", ");
  return parts;
};

export const formatStatus = (trackingState) => {
  if (trackingState === "BOZZA" || trackingState === "CONSEGNATA") return trackingState;
  if (trackingState === "RITIRO RICHIESTO") return "RITIRORICHIESTO";
  if (trackingState === "IN SPEDIZIONE") return "INSPEDIZIONE";
  return trackingState;
};

export const getStatusStep = (status) => {
  if (status === "PAID") return 1;
  if (status === "SENT") return 2;
  if (status === "RECEIVED") return 5;
  return 0;
};

export const getStatusBadgeKey = (status) => {
  if (status === "PAID") return "orderDetailsStatusToProcess";
  if (status === "SENT") return "orderDetailsStatusShipped";
  if (status === "RECEIVED") return "orderDetailsStatusDelivered";
  return "orderDetailsStatusToProcess";
};

export const isPositiveAmount = (value) => Number(value) > 0;

export const computeSellerNetReceived = (order) => {
  const sub = Number(order?.amountOrder) || 0;
  const fee = Number(order?.amountToPlatform) || 0;
  const cb = Number(order?.cashback) || 0;
  return sub - fee - cb;
};

export const buildTimelineEvents = (order) => {
  const date = order?.date;
  const currentStep = getStatusStep(order?.status);

  const steps = [
    {
      key: "confirmed",
      minStep: 1,
      icon: "pi pi-envelope",
      titleKey: "orderDetailsOrderConfirmed",
      descKey: "orderDetailsPaymentApproved",
    },
    {
      key: "transit",
      minStep: 2,
      icon: "pi pi-truck",
      titleKey: "orderDetailsStatusShipped",
      descKey: "orderDetailsProductInTransit",
    },
    {
      key: "delivered",
      minStep: 4,
      icon: "pi pi-check",
      titleKey: "orderDetailsStatusDelivered",
      descKey: "orderDetailsProductDelivered",
    },
  ];

  return steps
    .filter((step) => currentStep >= step.minStep)
    .map((step, index, filtered) => ({
      key: step.key,
      icon: step.icon,
      titleKey: step.titleKey,
      descKey: step.descKey,
      date,
      completed: index < filtered.length - 1,
    }));
};

